/* KI-Hautanalyse — Frontend-Flow (siehe HAUTANALYSE-KONZEPT.md §4)
 * Foto → /analyze läuft im Hintergrund, während der Nutzer die Fragen
 * beantwortet (mit Analyse-Indikator); dynamische Zusatzfragen aus der
 * Analyse werden angehängt; /recommend baut die Routine. Produkt-Cards
 * kommen serverseitig gerendert via Section Rendering API
 * (/products/{handle}?section_id=skin-analysis-card) → Preis, Grundpreis
 * (PAngV) und Sterne aus denselben Quellen wie die Collection-Cards.
 * Vanilla JS; Modell-/User-Texte werden nur via textContent gerendert. */
(function () {
  'use strict';

  var root = document.getElementById('skin-analysis');
  if (!root) return;

  var WORKER_URL = (root.dataset.workerUrl || '').replace(/\/$/, '');
  var TURNSTILE_KEY = root.dataset.turnstileKey || '';
  var LOCALE = root.dataset.locale || 'de';
  var ROUTES_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Shopifys t-Filter escapt HTML (& → &amp;) — für textContent-Rendering
     müssen die Entities zurückübersetzt werden. */
  var decodeTextarea = document.createElement('textarea');
  function decodeDeep(value) {
    if (typeof value === 'string') {
      if (value.indexOf('&') === -1) return value;
      decodeTextarea.innerHTML = value;
      return decodeTextarea.value;
    }
    if (Array.isArray(value)) return value.map(decodeDeep);
    if (value && typeof value === 'object') {
      var out = {};
      Object.keys(value).forEach(function (k) { out[k] = decodeDeep(value[k]); });
      return out;
    }
    return value;
  }
  function readJson(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  /* GA4-Funnel-Events (Doku: DOKU.md §11.1, Anleitung: docs/HAUTANALYSE-GA4-FUNNEL.md).
     Offizielles gtag-Queue-Pattern: existiert window.gtag (noch) nicht — z.B. weil
     GA erst nach Consent lädt — landen die Aufrufe im dataLayer und werden von
     gtag.js beim Laden nachverarbeitet. Tracking darf das Tool nie brechen. */
  function track(name, params) {
    try {
      var g = window.gtag;
      if (typeof g !== 'function') {
        window.dataLayer = window.dataLayer || [];
        g = function () { window.dataLayer.push(arguments); };
      }
      g('event', name, params || {});
    } catch (e) { /* bewusst still */ }
  }
  function modeParam() { return state.photoMode ? 'photo' : 'no_photo'; }

  var QUESTIONS = decodeDeep(readJson('ska-questions')) || [];
  var I18N = decodeDeep(readJson('ska-i18n')) || {};

  /* Schritt 2 (Revival Toner) wird als optionaler Zusatz-Schritt angezeigt
     und ist nicht Teil von „Komplette Routine in den Warenkorb". */
  var OPTIONAL_STEPS = { 2: true };

  /* Dimensionen der Detail-Einschätzung: Gruppierung des Concern-Vokabulars.
     Scores sind eine deterministische Darstellung der severity-Einstufung
     (keine Messwerte!): ohne Befund 9, leicht 7, moderat 5, deutlich 3. */
  var DETAIL_DIMENSIONS = [
    { key: 'unreinheiten', concerns: ['Unreinheiten', 'Mitesser'] },
    { key: 'roetungen', concerns: ['Rötungen', 'Sensible und gereizte Haut'] },
    { key: 'feuchtigkeit', concerns: ['Trockene und dehydrierte Haut', 'Schuppende Haut'] },
    { key: 'poren', concerns: ['Vergrößerte Poren'] },
    { key: 'pigment', concerns: ['Dunkle Flecken', 'Pickelmale'] },
    { key: 'falten', concerns: ['Falten', 'Reife Haut'] },
    { key: 'teint', concerns: ['Fahle und müde Haut'] },
    { key: 'augen', concerns: ['Augenpflege'] },
    { key: 'barriere', concerns: ['Hautbarriere'] }
  ];
  var SEVERITY_RANK = { leicht: 1, moderat: 2, deutlich: 3 };
  var RANK_SCORE = { 0: 9, 1: 7, 2: 5, 3: 3 };
  var RANK_LABEL_KEY = { 0: 'none', 1: 'leicht', 2: 'moderat', 3: 'deutlich' };

  /* ── State ── */
  var state = {
    photoB64: null,
    photoDataUrl: null,
    mediaType: 'image/jpeg',
    /* Kurzzeit-Pass vom Worker nach erster gelöster Turnstile-Challenge —
       deckt die Folge-Calls ab, damit die Challenge nicht mehrfach erscheint */
    sessionToken: null,
    photoMode: false,
    queue: [],
    index: 0,
    answers: {},
    analysisPromise: null,
    analysis: null,
    analysisError: null,
    analysisSettled: false,
    extrasAppended: false,
    questionsDone: false,
    lastFailed: null,
    waitTimer: null
  };

  /* ── DOM ── */
  var panels = {};
  ['intro', 'photo', 'questions', 'waiting', 'result', 'error'].forEach(function (name) {
    panels[name] = root.querySelector('[data-panel="' + name + '"]');
  });
  var el = {
    fileInput: root.querySelector('[data-file-input]'),
    preview: root.querySelector('[data-photo-preview]'),
    dropzoneLabel: root.querySelector('[data-dropzone-label]'),
    consent: root.querySelector('[data-consent]'),
    analyzeBtn: root.querySelector('[data-action="analyze"]'),
    photoError: root.querySelector('[data-photo-error]'),
    analyzing: root.querySelector('[data-analyzing]'),
    analyzingThumb: root.querySelector('[data-analyzing-thumb]'),
    analyzingText: root.querySelector('[data-analyzing-text]'),
    progress: root.querySelector('[data-progress]'),
    extraHint: root.querySelector('[data-extra-hint]'),
    questionTitle: root.querySelector('[data-question-title]'),
    options: root.querySelector('[data-options]'),
    multiHint: root.querySelector('[data-multi-hint]'),
    multiContinue: root.querySelector('[data-action="multi-continue"]'),
    questionBack: root.querySelector('[data-action="question-back"]'),
    waitingText: root.querySelector('[data-waiting-text]'),
    summary: root.querySelector('[data-summary]'),
    medicalNote: root.querySelector('[data-medical-note]'),
    observations: root.querySelector('[data-observations]'),
    observationList: root.querySelector('[data-observation-list]'),
    resultPhoto: root.querySelector('[data-result-photo]'),
    resultPhotoImg: root.querySelector('[data-result-photo-img]'),
    detail: root.querySelector('[data-detail]'),
    detailList: root.querySelector('[data-detail-list]'),
    qualityNote: root.querySelector('[data-quality-note]'),
    routine: root.querySelector('[data-routine]'),
    cards: root.querySelector('[data-cards]'),
    studyFootnote: root.querySelector('[data-study-footnote]'),
    addAll: root.querySelector('[data-action="add-all"]'),
    errorMessage: root.querySelector('[data-error-message]'),
    turnstileSlot: root.querySelector('[data-turnstile-slot]')
  };

  function showPanel(name) {
    Object.keys(panels).forEach(function (key) {
      if (panels[key]) panels[key].hidden = key !== name;
    });
    stopWaitTimer();
    var heading = panels[name] && panels[name].querySelector('[tabindex="-1"]');
    if (heading) heading.focus({ preventScroll: false });
    root.scrollIntoView({ block: 'start', behavior: 'auto' });
  }

  /* Analyse-Indikator im Fragen-Panel (Foto läuft im Hintergrund).
     Nach erfolgreicher Analyse NICHT ausblenden, sondern in den
     „Fertig“-Zustand wechseln — sonst springt der Fragebogen nach oben,
     sobald mitten im Beantworten die Rückfragen eintreffen. Ausgeblendet
     wird nur bei Fehler/unbrauchbarem Foto (dort wechselt der Flow ohnehin
     gleich Panel bzw. Meldung). */
  var analyzingDefaultText = el.analyzingText ? el.analyzingText.textContent : '';
  function updateAnalyzingIndicator() {
    var hasPhoto = state.photoMode && !!state.photoB64;
    var done = state.analysisSettled;
    var doneOk = done && !state.analysisError && state.analysis &&
      state.analysis.analysis_status !== 'unsuitable_image';
    var visible = hasPhoto && (!done || doneOk);
    /* Beim Wechsel auf „fertig“ die aktuelle Höhe einfrieren: Der kürzere
       Done-Text würde die Box sonst schrumpfen lassen (mehrzeilig → einzeilig
       auf Mobile) und der Fragebogen spränge nach oben. */
    if (visible && doneOk && !el.analyzing.hidden && !el.analyzing.classList.contains('ska-analyzing--done')) {
      el.analyzing.style.minHeight = el.analyzing.offsetHeight + 'px';
    }
    if (!doneOk) el.analyzing.style.minHeight = '';
    el.analyzing.hidden = !visible;
    el.analyzing.classList.toggle('ska-analyzing--done', !!(visible && doneOk));
    if (el.analyzingText) {
      el.analyzingText.textContent = (visible && doneOk && I18N.analyzed_hint)
        ? I18N.analyzed_hint
        : analyzingDefaultText;
    }
    if (visible && state.photoDataUrl && el.analyzingThumb.src !== state.photoDataUrl) {
      el.analyzingThumb.src = state.photoDataUrl;
    }
  }

  /* ── Fragen-Queue ── */
  function buildQueue(photoMode) {
    /* photoOnly-Fragen nur mit Foto (z.B. Make-up), noPhotoOnly-Fragen nur
       ohne Foto (z.B. Mehrfachauswahl weiterer Hautthemen — mit Foto liefert
       die Bildanalyse diese Information selbst). */
    state.queue = QUESTIONS.filter(function (q) { return photoMode ? !q.noPhotoOnly : !q.photoOnly; })
      .map(function (q) { return { id: q.id, title: q.title, options: q.options, multi: !!q.multi, dynamic: false }; });
    state.index = 0;
    state.answers = {};
    state.questionsDone = false;
    state.extrasAppended = false;
  }

  function renderQuestion() {
    var q = state.queue[state.index];
    if (!q) { finishQuestions(); return; }
    showPanel('questions');
    updateAnalyzingIndicator();
    el.progress.textContent = (I18N.progress || '__X__/__Y__')
      .replace('__X__', state.index + 1)
      .replace('__Y__', state.queue.length);
    el.extraHint.hidden = !q.dynamic;
    el.questionTitle.textContent = q.title;
    el.options.textContent = '';
    el.multiHint.hidden = !q.multi;
    el.multiContinue.hidden = !q.multi;

    if (q.multi) {
      /* Mehrfachauswahl: Chips togglen (aria-pressed), Weiter-Button schließt
         den Schritt ab. Antwort = Array der gewählten Werte (darf leer sein).
         Die bereits gewählte Hauptanliegen-Option wird nicht erneut angeboten. */
      var selected = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];
      q.options.forEach(function (opt) {
        if (opt.v === state.answers.main_concern) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ska-chip';
        btn.textContent = opt.l;
        btn.setAttribute('aria-pressed', selected.indexOf(opt.v) !== -1 ? 'true' : 'false');
        btn.addEventListener('click', function () {
          var pos = selected.indexOf(opt.v);
          if (pos === -1) selected.push(opt.v); else selected.splice(pos, 1);
          btn.setAttribute('aria-pressed', pos === -1 ? 'true' : 'false');
        });
        el.options.appendChild(btn);
      });
      el.multiContinue.onclick = function () {
        var values = selected.filter(function (v) { return v !== state.answers.main_concern; });
        state.answers[q.id] = values;
        track('ska_question_answered', {
          step_number: state.index + 1,
          question_id: q.id,
          question_type: q.dynamic ? 'dynamic' : 'standard',
          selected_count: values.length,
          mode: modeParam()
        });
        state.index++;
        renderQuestion();
      };
    } else {
      q.options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ska-chip';
        btn.textContent = opt.l;
        btn.addEventListener('click', function () {
          track('ska_question_answered', {
            step_number: state.index + 1,
            question_id: q.id,
            question_type: q.dynamic ? 'dynamic' : 'standard',
            mode: modeParam()
          });
          state.answers[q.id] = opt.v;
          state.index++;
          renderQuestion();
        });
        el.options.appendChild(btn);
      });
    }
    el.questionBack.hidden = state.index === 0;
    el.questionTitle.focus();
  }

  function finishQuestions() {
    state.questionsDone = true;
    maybeProceed();
  }

  function appendExtraQuestions(extras) {
    if (state.extrasAppended || !extras || !extras.length) return false;
    state.extrasAppended = true;
    extras.forEach(function (q) {
      state.queue.push({
        id: q.id,
        title: q.question,
        options: q.options.map(function (o) { return { v: o, l: o }; }),
        dynamic: true
      });
    });
    return true;
  }

  /* ── Analyse (Call 1) ── */
  function startAnalyze() {
    state.analysis = null;
    state.analysisError = null;
    state.analysisSettled = false;
    state.analysisPromise = (state.sessionToken ? Promise.resolve(null) : getTurnstileToken())
      .then(function (token) {
        return api('/analyze', {
          image: state.photoB64,
          media_type: state.mediaType,
          locale: LOCALE,
          turnstile_token: token,
          session_token: state.sessionToken
        });
      })
      .then(function (res) {
        if (res.session) state.sessionToken = res.session;
        state.analysis = res.analysis;
        state.analysisSettled = true;
        updateAnalyzingIndicator();
        if (!state.questionsDone && state.analysis.analysis_status !== 'unsuitable_image') {
          appendExtraQuestions(state.analysis.extra_questions);
          if (!panels.questions.hidden) renderQuestion();
        }
        maybeProceed();
      })
      .catch(function (err) {
        state.analysisError = err;
        state.analysisSettled = true;
        updateAnalyzingIndicator();
        maybeProceed();
      });
  }

  /* Wird aufgerufen, sobald Fragen fertig ODER Analyse fertig ist. */
  function maybeProceed() {
    if (!state.questionsDone) return;
    if (state.photoMode && !state.analysisSettled) { showWaiting('analyze'); return; }

    if (state.analysisError) {
      state.lastFailed = 'analyze';
      showError(errorText(state.analysisError));
      return;
    }
    if (state.analysis && state.analysis.analysis_status === 'unsuitable_image') {
      state.photoB64 = null;
      state.photoDataUrl = null;
      el.preview.hidden = true;
      el.dropzoneLabel.hidden = false;
      el.analyzeBtn.disabled = true;
      el.photoError.textContent = (state.analysis.image_quality_note || '') || (I18N.errors && I18N.errors.unsuitable_image) || '';
      el.photoError.hidden = false;
      track('ska_photo_rejected', { mode: 'photo' });
      showPanel('photo');
      return;
    }
    if (state.analysis && appendExtraQuestions(state.analysis.extra_questions)) {
      state.questionsDone = false;
      renderQuestion();
      return;
    }
    doRecommend();
  }

  /* ── Empfehlung (Call 2) ── */
  function doRecommend(isRetry) {
    if (!isRetry) track('ska_questions_completed', { steps_total: state.queue.length, mode: modeParam() });
    showWaiting('recommend');
    (state.sessionToken ? Promise.resolve(null) : getTurnstileToken())
      .then(function (token) {
        return api('/recommend', {
          analysis: state.analysis,
          answers: state.answers,
          locale: LOCALE,
          turnstile_token: token,
          session_token: state.sessionToken
        });
      })
      .then(function (res) {
        if (res.session) state.sessionToken = res.session;
        renderResult(res.result);
      })
      .catch(function (err) {
        /* Session abgelaufen/ungültig (api() hat sie bereits verworfen):
           einmal still mit frischer Challenge wiederholen statt Fehler zeigen */
        if (err && err.code === 'turnstile_failed' && !isRetry) { doRecommend(true); return; }
        state.lastFailed = 'recommend';
        showError(errorText(err));
      });
  }

  /* ── Ergebnis ── */
  function renderResult(result) {
    el.summary.textContent = result.summary_text || '';

    var medical = result.medical_note || (state.analysis && state.analysis.medical_note);
    el.medicalNote.hidden = !medical;
    if (medical) el.medicalNote.textContent = medical;

    var obs = (state.analysis && state.analysis.observations) || [];
    el.observations.hidden = obs.length === 0 && !state.photoDataUrl;

    if (state.photoDataUrl) {
      el.resultPhotoImg.src = state.photoDataUrl;
      el.resultPhoto.hidden = false;
    } else {
      el.resultPhoto.hidden = true;
    }

    el.observationList.textContent = '';
    obs.forEach(function (o) {
      var li = document.createElement('li');
      var label = (I18N.concerns && I18N.concerns[o.concern]) || o.concern;
      var sev = (I18N.severity && I18N.severity[o.severity]) || o.severity;
      li.textContent = label + ' · ' + o.area + ' (' + sev + ')';
      el.observationList.appendChild(li);
    });

    var quality = state.analysis && state.analysis.image_quality_note;
    el.qualityNote.hidden = !quality;
    if (quality) el.qualityNote.textContent = quality;

    renderDetailScores(obs);

    /* Nach Routine-Schritt sortieren und durchgehend nummerieren (1..n):
       Fällt z.B. der optionale Toner (Schritt 2) weg, stünde sonst
       „Schritt 1, Schritt 3, …“ — sieht nach Lücke aus. Der Kategorie-Name
       (Cleanser/Booster/…) bleibt an der echten Routine-Position hängen. */
    var recs = (result.recommendations || []).slice().sort(function (a, b) { return a.step - b.step; });
    track('ska_result', { recommendations_count: recs.length, mode: modeParam() });
    el.routine.hidden = recs.length === 0;
    el.cards.textContent = '';
    showPanel('result');
    if (!recs.length) return;

    Promise.all(recs.map(fetchCard)).then(function (items) {
      var addable = [];
      var displayStep = 0;
      items.forEach(function (item) {
        if (!item) return;
        displayStep++;
        var wired = wireCard(item.rec, item.node, displayStep);
        el.cards.appendChild(item.node);
        if (wired.addToAll) addable.push(wired.variantId);
      });
      el.addAll.disabled = addable.length === 0;
      el.addAll.onclick = function () { addAllToCart(addable); };
      /* Studien-Fußnote nur zeigen, wenn mindestens eine Studien-Box sichtbar ist */
      var studyBoxen = items.filter(function (i) { return i && i.rec.study_result; }).length;
      if (el.studyFootnote) el.studyFootnote.hidden = studyBoxen === 0;
    }).catch(function (err) {
      console.error('[skin-analysis] Karten-Rendering fehlgeschlagen:', err);
    });
  }

  /* Detail-Einschätzung: deterministische Darstellung der Beobachtungen */
  function renderDetailScores(observations) {
    var hasAnalysis = state.photoMode && state.analysis && state.analysis.analysis_status !== 'unsuitable_image';
    el.detail.hidden = !hasAnalysis;
    if (!hasAnalysis) return;
    el.detailList.textContent = '';
    DETAIL_DIMENSIONS.forEach(function (dim) {
      var rank = 0;
      observations.forEach(function (o) {
        if (dim.concerns.indexOf(o.concern) !== -1) {
          rank = Math.max(rank, SEVERITY_RANK[o.severity] || 1);
        }
      });
      var score = RANK_SCORE[rank];
      var label = (I18N.detail_labels && I18N.detail_labels[RANK_LABEL_KEY[rank]]) || '';

      var li = document.createElement('li');
      var name = document.createElement('span');
      name.className = 'ska-detail-name';
      name.textContent = (I18N.detail_dims && I18N.detail_dims[dim.key]) || dim.key;
      li.appendChild(name);

      var bar = document.createElement('span');
      bar.className = 'ska-detail-bar';
      if (rank >= 2) bar.classList.add('is-attention');
      var fill = document.createElement('i');
      fill.style.width = (score * 10) + '%';
      bar.appendChild(fill);
      li.appendChild(bar);

      var scoreEl = document.createElement('span');
      scoreEl.className = 'ska-detail-score';
      scoreEl.textContent = score + '/10 · ' + label;
      li.appendChild(scoreEl);

      el.detailList.appendChild(li);
    });
  }

  /* Server-gerenderte Card via Section Rendering API laden */
  function fetchCard(rec) {
    var url = ROUTES_ROOT + 'products/' + encodeURIComponent(rec.product_handle) + '?section_id=skin-analysis-card';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-ska-card]');
        return node ? { rec: rec, node: node } : null;
      })
      .catch(function () { return null; });
  }

  function wireCard(rec, node, displayStep) {
    var optional = !!OPTIONAL_STEPS[rec.step];
    var stepSlot = node.querySelector('[data-slot="step"]');
    if (stepSlot) {
      stepSlot.textContent = (I18N.step_label || '__N__ __NAME__')
        .replace('__N__', displayStep || rec.step)
        .replace('__NAME__', (I18N.step_names && I18N.step_names[rec.step]) || '');
    }
    var optionalBadge = node.querySelector('[data-slot="optional"]');
    if (optionalBadge) optionalBadge.hidden = !optional;
    if (optional) node.classList.add('ska-card--optional');

    var reasonSlot = node.querySelector('[data-slot="reason"]');
    if (reasonSlot) reasonSlot.textContent = rec.reason || '';

    var studySlot = node.querySelector('[data-slot="study"]');
    if (studySlot && rec.study_result) {
      var studyText = studySlot.querySelector('[data-slot="study-text"]');
      if (studyText) studyText.textContent = rec.study_result;
      studySlot.hidden = false;
    }

    var variantId = node.getAttribute('data-variant-id');
    var available = node.getAttribute('data-available') === 'true';
    var btn = node.querySelector('[data-ska-atc]');
    if (btn && available && variantId) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var original = btn.textContent;
        btn.textContent = I18N.adding || '…';
        addToCart(variantId).then(function (ok) {
          if (ok) track('ska_add_to_cart', { scope: 'single', product_handle: rec.product_handle, routine_step: rec.step });
          btn.textContent = ok ? (I18N.added || original) : original;
          if (!ok) btn.disabled = false;
        });
      });
    }
    return { variantId: variantId, addToAll: available && !!variantId && !optional };
  }

  function addToCart(variantId) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    return fetch(ROUTES_ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        if (typeof window.openCart === 'function') window.openCart();
        return true;
      })
      .catch(function () { return false; });
  }

  function addAllToCart(variantIds) {
    if (!variantIds.length) return;
    el.addAll.disabled = true;
    var label = el.addAll.textContent;
    el.addAll.textContent = I18N.adding || '…';
    fetch(ROUTES_ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add all failed');
        track('ska_add_to_cart', { scope: 'all', items_count: variantIds.length });
        el.addAll.textContent = I18N.added || label;
        if (typeof window.openCart === 'function') window.openCart();
      })
      .catch(function () {
        el.addAll.disabled = false;
        el.addAll.textContent = label;
      });
  }

  /* ── Foto-Verarbeitung (Downscale + EXIF-Strip via Canvas-Re-Encode) ── */
  function processFile(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        try {
          var max = 1024;
          var scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
          var w = Math.round(img.naturalWidth * scale);
          var h = Math.round(img.naturalHeight * scale);
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          var dataUrl = canvas.toDataURL('image/jpeg', 0.82);
          URL.revokeObjectURL(url);
          resolve(dataUrl);
        } catch (e) { reject(e); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
      img.src = url;
    });
  }

  /* ── Turnstile (optional) ── */
  var turnstileWidget = null;
  var turnstileScript = null;
  function loadTurnstile() {
    if (turnstileScript) return turnstileScript;
    turnstileScript = new Promise(function (resolve, reject) {
      if (window.turnstile) { resolve(); return; }
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return turnstileScript;
  }
  function getTurnstileToken() {
    if (!TURNSTILE_KEY) return Promise.resolve(null);
    return loadTurnstile().then(function () {
      return new Promise(function (resolve) {
        if (turnstileWidget === null) {
          turnstileWidget = window.turnstile.render(el.turnstileSlot, {
            sitekey: TURNSTILE_KEY,
            size: 'flexible',
            appearance: 'interaction-only',
            /* Widget-Fehler (z.B. Domain nicht in der Turnstile-Konfiguration):
               sofort ohne Token weiter — der Worker antwortet dann mit einem
               definierten Fehler statt dass das Tool endlos im Warten hängt. */
            'error-callback': function () { resolve(null); return true; }
          });
        } else {
          window.turnstile.reset(turnstileWidget);
        }
        var waited = 0;
        (function poll() {
          var token = null;
          /* getResponse kann bei fehlerhaftem Widget-Zustand werfen — ohne
             try/catch stürbe die Poll-Kette und das Promise bliebe ewig offen. */
          try { token = window.turnstile.getResponse(turnstileWidget); }
          catch (e) { resolve(null); return; }
          if (token) { resolve(token); return; }
          waited += 250;
          if (waited > 20000) { resolve(null); return; }
          setTimeout(poll, 250);
        })();
      });
    }).catch(function () { return null; });
  }

  /* ── API + Fehler ── */
  function api(path, payload) {
    if (!WORKER_URL) return Promise.reject({ code: 'not_configured' });
    return fetch(WORKER_URL + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        if (!r.ok) {
          /* Abgelaufene/ungültige Session verwerfen — der nächste Versuch
             holt dann wieder ein frisches Turnstile-Token */
          if (body.error === 'turnstile_failed') state.sessionToken = null;
          throw { code: body.error || 'generic', status: r.status };
        }
        return body;
      });
    }, function () { throw { code: 'network' }; });
  }

  function errorText(err) {
    var errors = I18N.errors || {};
    return errors[err && err.code] || errors.generic || 'Fehler';
  }

  function showError(message) {
    track('ska_error', { stage: state.lastFailed || 'analyze', mode: modeParam() });
    el.errorMessage.textContent = message;
    showPanel('error');
  }

  /* ── Warte-Panel mit rotierenden Texten ── */
  function showWaiting(kind) {
    var texts = kind === 'analyze' ? I18N.waiting_analyze : I18N.waiting_recommend;
    texts = texts && texts.length ? texts : ['…'];
    showPanel('waiting');
    var i = 0;
    el.waitingText.textContent = texts[0];
    stopWaitTimer();
    state.waitTimer = setInterval(function () {
      i = (i + 1) % texts.length;
      el.waitingText.textContent = texts[i];
    }, 3500);
  }
  function stopWaitTimer() {
    if (state.waitTimer) { clearInterval(state.waitTimer); state.waitTimer = null; }
  }

  /* ── Events ── */
  root.querySelector('[data-action="start"]').addEventListener('click', function () {
    state.photoMode = true;
    track('ska_start', { mode: 'photo' });
    showPanel('photo');
  });
  root.querySelector('[data-action="start-without-photo"]').addEventListener('click', function () {
    state.photoMode = false;
    track('ska_start', { mode: 'no_photo' });
    state.analysisPromise = null;
    state.analysis = null;
    state.analysisError = null;
    state.analysisSettled = true;
    buildQueue(false);
    track('ska_questions_started', { mode: 'no_photo', steps_total: state.queue.length });
    renderQuestion();
  });
  root.querySelector('[data-action="back-to-intro"]').addEventListener('click', function () {
    showPanel('intro');
  });
  el.questionBack.addEventListener('click', function () {
    if (state.index === 0) return;
    state.index--;
    delete state.answers[state.queue[state.index].id];
    renderQuestion();
  });
  el.fileInput.addEventListener('change', function () {
    var file = el.fileInput.files && el.fileInput.files[0];
    if (!file) return;
    processFile(file).then(function (dataUrl) {
      state.photoB64 = dataUrl.split(',')[1];
      state.photoDataUrl = dataUrl;
      state.mediaType = 'image/jpeg';
      el.preview.src = dataUrl;
      el.preview.hidden = false;
      el.dropzoneLabel.hidden = true;
      el.photoError.hidden = true;
      updateAnalyzeButton();
    }).catch(function () {
      el.photoError.textContent = (I18N.errors && I18N.errors.generic) || '';
      el.photoError.hidden = false;
    });
  });
  el.consent.addEventListener('change', updateAnalyzeButton);
  function updateAnalyzeButton() {
    el.analyzeBtn.disabled = !(state.photoB64 && el.consent.checked);
  }
  el.analyzeBtn.addEventListener('click', function () {
    if (!state.photoB64) return;
    if (!el.consent.checked) {
      el.photoError.textContent = I18N.photo_missing_consent || '';
      el.photoError.hidden = false;
      return;
    }
    startAnalyze();
    if (state.questionsDone || state.queue.length) {
      /* Rückkehr nach unsuitable_image: Fragen sind schon (teilweise) beantwortet */
      if (state.index >= state.queue.length) { state.questionsDone = true; showWaiting('analyze'); }
      else renderQuestion();
    } else {
      buildQueue(true);
      track('ska_questions_started', { mode: 'photo', steps_total: state.queue.length });
      renderQuestion();
    }
  });
  root.querySelectorAll('[data-action="restart"]').forEach(function (btn) {
    btn.addEventListener('click', function () { window.location.reload(); });
  });
  root.querySelector('[data-action="retry"]').addEventListener('click', function () {
    if (state.lastFailed === 'recommend') { doRecommend(); return; }
    if (state.lastFailed === 'analyze' && state.photoB64) {
      startAnalyze();
      showWaiting('analyze');
      return;
    }
    window.location.reload();
  });
})();
